import { render, staticRenderFns } from "./SystemTypeInputConfig.vue?vue&type=template&id=0a029746"
import script from "./SystemTypeInputConfig.vue?vue&type=script&lang=js"
export * from "./SystemTypeInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports